import React, { Suspense, lazy } from 'react'

const Loadable = Component => props => (
  <Suspense fallback={<></>}>
    <Component {...props} />
  </Suspense>
)

export const createLoadable = loader => Loadable(lazy(loader))
